const initSelect = () => {
    window.addEventListener('load', function () {
        var payOption = document.querySelectorAll('.pay-table-row');
        var checked = false;
        for (var i = 0; i < payOption.length; i++) {
            if (payOption[i].getElementsByTagName('input')[0].checked) {
                checked = true;
                break;
            }
        }
        if (checked == false) {
            payOption[0].getElementsByTagName('input')[0].checked = true;
        }
        payOption.forEach(function (payRow: HTMLElement) {
            var payMethod = payRow.getElementsByTagName('input')[0] as HTMLInputElement;
            if (!payMethod.disabled) {
                payRow.addEventListener("click", function () {
                    var i;
                    var inputList = document.getElementsByTagName('input');
                    for (i = 0; i < inputList.length; i++) {
                        inputList[i].checked = false;
                    }

                    payRow.getElementsByTagName('input')[0].checked = true;
                })
            } else {
                payRow.style.cursor = 'default';
            }

        });
    });
};

export {
    initSelect
};
